import '../../css/base.css';
import cottage1_large from '../../img/cottage/cottage1_large.jpg'
import cottage1_medium from '../../img/cottage/cottage1_medium.jpg'
import cottage1_small from '../../img/cottage/cottage1_small.jpg'

const TheCottage = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">The Cottage</h2>
      <p className="your-stay-text">Shore Cottage is situated on Loch Hourn in the tiny, picturesque
                                    community of Arnisdale. There are no shops, pubs, café’s or restaurants
                                    in Arnisdale itself so make sure you stock up with food shopping before
                                    you arrive. The nearest local shop is nine miles away in Glenelg and it
                                    only stocks the basics! We normally stop at Morrison’s in Fort William on
                                    our way up and do a large supplies shop there.
      </p>
      <p className="your-stay-text">The cottage is right on the small road that runs through the village and
                                    although not a busy road cars do come past, sometimes at speed. 
                                    <strong> Therefore we strongly advise that children and pets come in and out
                                    the cottage via the back door</strong>. This gives them and any vehicles more
                                    time to see each other, stepping or running straight out the front door does
                                    not. Please keep the side gates to the cottage closed.
      </p>
      <div className="row d-none d-md-block home-image">
        <div className="col-10 offset-1">
          <div className="imagesBackgroundColour">
            <picture>
              <source srcSet={`${cottage1_small} 1x,${cottage1_medium} 2x`} media="(max-width: 600px)" />
              <img srcSet={`${cottage1_medium} 1x,${cottage1_large} 2x`}
                src={cottage1_medium} alt="Cottage from the beach" className="image"
              />
            </picture>
          </div>             
        </div>
      </div>
    </div>
  );
}

export default TheCottage;